import MapboxLocationSearch from '@apps-common/location-search/MapboxLocationSearch.jsx';
import {Box} from '@mui/material';
import React from 'react';
import {useDispatch} from 'react-redux';
import {fitExtent} from '@app/actions/map';
import {notify} from '@app/actions/notifications';
import {trackEvent} from '@app/analytics';
import {MAPBOX_ACCESS_TOKEN} from '@app/config.js';
import useMapViewParams from '@app/hooks/useMapViewParams';
import {getExtent} from '@app/util/geom';

const SearchInput = () => {
  const dispatch = useDispatch();
  const {center} = useMapViewParams();

  const selectResult = result => {
    if (result) {
      trackEvent('Search Input', {
        action: 'Selected result',
        query: result.query || result.title,
        source: result.source,
      });

      const extent = getExtent(result.geometry);
      dispatch(
        fitExtent([extent.left, extent.bottom, extent.right, extent.top])
      );
    }
  };

  const onError = () => {
    dispatch(
      notify({
        message: 'There was an error executing the search',
        severity: 'error',
      })
    );
  };

  return (
    <Box sx={{width: 392}}>
      <MapboxLocationSearch
        center={[center[1], center[0]]}
        onError={onError}
        onSelectOption={selectResult}
        accessToken={MAPBOX_ACCESS_TOKEN}
      />
    </Box>
  );
};

export default SearchInput;
